// extracted by mini-css-extract-plugin
module.exports = {"variants":"ProductVariants_variants__KS8X6","toastContainer":"ProductVariants_toastContainer__x5np0"};